module.exports = __webpack_public_path__ + "img/icon-restar.19a4d1ba.svg";